<template>
  <div>
    <b-row class="mt-4">
      <b-col cols="1">
        <h3 class="text-info m-1">2.</h3>
      </b-col>
      <b-col>
        <ulu-date-picker
          class="m-1"
          v-model="date"
          lang="en"
          format="DD.MM.YYYY"
          :clearable="false"
          :placeholder="$t('globals.set_starting_date')"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="1"></b-col>
      <b-col>
        <b-form-checkbox
          v-model="retroactiveInvoicing"
          class="m-1"
        >
          {{ $t('globals.retroactive_invoicing') }}
        </b-form-checkbox>
        <small class="text-muted ml-4 d-block">
          {{ $t('globals.retroactive_invoicing_description') }}
        </small>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { mapMutations } from "vuex";

export default {
  components: {
    "ulu-date-picker": DatePicker
  },
  data() {
    return {
      date: "",
      retroactiveInvoicing: false
    };
  },
  methods: {
    ...mapMutations(["setNewInquiryStartingDate", "setNewInquiryRetroactiveInvoicing"])
  },
  watch: {
    date: function() {
      this.setNewInquiryStartingDate(this.date);
    },
    retroactiveInvoicing: function() {
      this.setNewInquiryRetroactiveInvoicing(this.retroactiveInvoicing);
    }
  }
};
</script>
